// extracted by mini-css-extract-plugin
export var columnItem = "_dx-3";
export var columnItemDraggable = "_dx-4";
export var dragHandle = "_dx-0";
export var dragHandleHovered = "_dx-1";
export var dropdown = "_dx-5";
export var dropdownContent = "_dx-7";
export var dropdownInner = "_dx-6";
export var filterDropdownHeader = "_dx-8";
export var icon = "_dx-2";
export var sectionDivider = "_dx-9";